import { apiRequest } from "@shared/services/api/apiRequest";

export async function completeDirectUpload(uploadInfo, file, metadata = {}) {
  const payload = {
    s3_key: uploadInfo.s3_key,
    file_name: file.name,
    file_size: file.size,
    file_type: metadata.file_type || "document",
    organization_id: metadata.organization_id,
  };

  const response = await apiRequest(
    "/api/complete-direct-upload/",
    "POST",
    payload,
    true
  );

  return response;
}

export default completeDirectUpload;
